import React from 'react'
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { SectionRoutes } from './Constants/routes';

const SectionsAll = () => {
  const match = useRouteMatch();

  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {SectionRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/sections" />
      </Switch>
    </>
  )
}

export default SectionsAll;
